// src/services/firebase.ts
import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import {
  initializeFirestore,
  enableIndexedDbPersistence,
  enableMultiTabIndexedDbPersistence,
  CACHE_SIZE_UNLIMITED,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!,
};

const app = initializeApp(firebaseConfig);

// Performance, Auth & Storage
export const perf = getPerformance(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Firestore initialisieren mit unbegrenztem Cache
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
});

// Single-Tab Offline-Persistence aktivieren
enableIndexedDbPersistence(db).catch((err: any) => {
  if (err.code === "failed-precondition") {
    console.warn(
      "Offline-Persistence (Single-Tab) nicht aktiviert (mehrere Tabs?):",
      err.message
    );
  } else if (err.code === "unimplemented") {
    console.warn(
      "Offline-Persistence (Single-Tab) nicht unterstützt:",
      err.message
    );
  } else {
    console.error("Fehler beim Aktivieren der Offline-Persistence:", err);
  }
});

// Multi-Tab Offline-Persistence aktivieren
enableMultiTabIndexedDbPersistence(db).catch((err: any) => {
  console.warn(
    "Multi-Tab Offline-Persistence nicht aktiviert:",
    err.message
  );
});
